<template>
  <VWidget content-class="pa-0" css-class="flex-grow-1">
    <template slot="title">{{ $t('title') }}</template>
    <template slot="header-actions">
      <NewGroup isIconBtn v-if="allowCreation" />
    </template>
    <template slot="content" v-if="loading">
      <v-loading />
    </template>
    <template slot="content" v-else>
      <GroupUsers
        v-for="group in groups"
        :key="`group-detail-${group.refname}`"
        :group="group"
        :attributions="attributions"
      />
    </template>
  </VWidget>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { VWidget, VLoading } from '@argon/app/components'
import GroupUsers from './GroupUsers'
import NewGroup from './NewGroup'
import groupPerimeter from '../perimeters'
import { NAMESPACE } from '../store'
import { NAMESPACE as ATTR_NAMESPACE } from '@argon/iam/attributions/store'

export default {
  name: 'GroupsList',
  components: { GroupUsers, NewGroup, VWidget, VLoading },
  perimeters: [groupPerimeter],
  props: {
    users: { type: Array, default: () => [] },
    allowCreation: { type: Boolean, default: false }
  },
  data: () => ({ loading: true }),
  computed: {
    ...mapState(NAMESPACE, ['groups']),
    ...mapState(ATTR_NAMESPACE, ['attributions'])
  },
  methods: {
    ...mapActions(NAMESPACE, ['listGroups', 'clearGroups'])
  },
  created() {
    this.listGroups({})
      .catch(() => {})
      .finally(() => {
        this.loading = false
      })
  },
  destroyed() {
    this.clearGroups()
  }
}
</script>

<i18n>
{
  "en": {
    "title": "@:labels.groups"
  },
  "fr": {
    "title": "@:labels.groups"
  }
}
</i18n>
